<template>
  <v-card :class="marginX">
    <v-layout row wrap>
      <v-flex sm12>
        <v-img :src="post.main_image" height="100" min-width="100" class="ma-1"/>
      </v-flex>
      <v-flex sm12>
        <v-card-title primary-title class="py-1">
          <div style="height: 5rem">
            <div class="caption-security grey-security">{{ post.published_at }}</div>
            <div 
              :title="post.full_title" 
              :class="stylePostTitle"
            >
              {{ postTitle }}
            </div>
          </div>
        </v-card-title>
      </v-flex>
    </v-layout>
  </v-card>
</template>
<script>
export default {
  props: {
    post: { type: Object, required: true },
    marginX: { type: String, required: true }
  },
  computed: {
    postTitle() {
      if (this.post.title.length >= 35) {
        return this.withScreen <= 330 ? `${this.post.title.slice(0, 30)}...` : `${this.post.title.slice(0, 35)}...`
      } else {
        return this.post.title
      }
    },
    withScreen() {
      return this.$vuetify.breakpoint.width
    },
    stylePostTitle() {
      return this.withScreen <= 330 ? 'text-12-security blue-security font-weight-bold' : 'text-13-security blue-security font-weight-bold'
    }
  },
}
</script>
<style>
  
</style>